var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector16AddModuleLIne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 1,
    viewBox: "0 0 80 1",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5H80",
    stroke: "#B2B2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector16AddModuleLIne);
export default __webpack_public_path__ + "static/media/Vector 16AddModuleLIne.26f57f3ee2d02ae02813d5b61d182e7c.svg";
export { ForwardRef as ReactComponent };